import apiClient from '../client';

export interface ChartDataParams {
  currency: string;
  interval: string;
  startTime: number;
  endTime: number;
}

export interface CandleData {
  time: number;
  open: number;
  high: number;
  low: number;
  close: number;
  volume: number;
}

export interface HomeCurrencyData {
  symbol: string;
  name: string;
  current_price: number;
  price_change_percentage_24h: number;
  image: string;
}

export const chartAPI = {
  /**
   * Get main chart candlestick data from Binance
   * Returns kline data for BTC/USDT
   */
  getMainChartData: async (params: ChartDataParams): Promise<CandleData[]> => {
    const response = await apiClient.get<number[][]>('/binance/get-main-chart-data', {
      params,
    });

    // Transform Binance kline data to candlestick format
    // Response format: [timestamp, open, high, low, close, volume, ...]
    const transformed = response.data.map((item) => ({
      time: Math.floor(item[0] / 1000), // Convert to seconds for lightweight-charts
      open: parseFloat(String(item[1])),
      high: parseFloat(String(item[2])),
      low: parseFloat(String(item[3])),
      close: parseFloat(String(item[4])),
      volume: parseFloat(String(item[5])),
    }));

    // Return last 30 candles
    return transformed.slice(0, 30);
  },

  /**
   * Get home currency data (BTC info with 24h change)
   */
  getHomeCurrencyData: async (): Promise<HomeCurrencyData> => {
    const response = await apiClient.get<HomeCurrencyData>('/assets/get-home-symbol-data');
    return response.data;
  },
};
